import type { ElementType } from 'react'

import { EasySearchHitDto } from '@dhl/mdp-api'
import { isProbablyJson, isProbablyCsv, isProbablyXml } from '~/modules/ppp/helpers'
import { JsonRenderer, PlainRenderer, CsvRenderer, XmlRenderer } from '~/modules/ppp/components/renderers'

type Props = {
  hit: EasySearchHitDto
  highlight?: string
}

const componentForValue = ({ payload = '' }: EasySearchHitDto): ElementType => {
  switch (true) {
    case isProbablyJson(payload):
      return function (props: any) {
        return <JsonRenderer {...props} filterNulls />
      }
    case isProbablyCsv(payload):
      return CsvRenderer
    case isProbablyXml(payload):
      return XmlRenderer
    default:
      return PlainRenderer
  }
}
export const PppHitDisplay = ({ hit, highlight }: Props) => {
  const Component = componentForValue(hit)
  return <Component value={hit.payload} highlight={highlight} />
}
